<template>
  <div class="StudentTutorsModalEdit">
    <btn class="edit" @click.native="showModal"><i class="fa fa-pencil"></i></btn>
    <component-modal v-show="condition.condition" transition="expand">
      <template slot="title">探しデータ編集</template>
      <div slot="body">
        <table class="m-table">
          <tbody>
            <tr>
              <th>教師名</th>
              <td>{{list.tutor.f_name}} {{list.tutor.l_name}}</td>
            </tr>
            <tr>
              <th>指導開始日</th>
              <td>
                <input type="text" maxlength="10" minlength="10" v-model="list.guidance_period_start" placeholder="指導開始日">
              </td>
            </tr>
            <tr>
              <th>指導終了日</th>
              <td>
                <input type="text" maxlength="10" minlength="10" v-model="list.guidance_period_end" placeholder="指導終了日">
              </td>
            </tr>
            <tr>
              <th>探し提出日</th>
              <td>
                <input type="text" maxlength="10" minlength="10" v-model="list.filing_date" placeholder="探し提出日">
              </td>
            </tr>
            <tr>
              <th>探し種類</th>
              <td>
                <input type='text' v-model="list.matching_type">
              </td>
            </tr>
            <tr>
              <th>チェンジ理由</th>
              <td>
                <input type='text' v-model="list.change_reason">
              </td>
            </tr>
            <tr>
              <th>探し月</th>
              <td>
                <input type='text' v-model="list.matching_month">
              </td>
            </tr>
            <tr>
              <th>備考</th>
              <td>
                <textarea type='text' v-model="list.note"></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="footer" slot="footer">
        <btn @click.native="patchStudent_tutor(list)">更新</btn>
        <btn @click.native="showModal">キャンセル</btn>
      </div>
    </component-modal>
  </div>
</template>

<script>
export default {
  props: {
    list: Object
  },
  computed: {
  },
  name: 'StudentTutorsModalEdit',
  data () {
    return {
      condition: {
        condition: false
      }
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(selectedOption.name)
      // console.log(selectedOption.value)
    },

    showModal () {
      this.condition.condition = !this.condition.condition
    },

    patchStudent_tutor (list) {
      this.$store.dispatch('patchStudent_tutor', {
        list: list,
        condition: this.condition
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.req {
  background: #dffbef;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
table {
  border-spacing: 0;
  width: 100%;
  tr {
    th {
      border-bottom: solid 1px #ddd;
      background: #f4f4f4;
      color: #333;
      padding: 10px;
      width: 150px;
    }
    td {
      border-bottom: solid 1px #ddd;
      input {
        outline: 0;
        border: none;
        width: 100%;
      }
      .half {
        width: 50%;
      }
      textarea {
        outline: 0;
        border: none;
        width: 100%;
        height: 100px;
      }
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
.edit {
  background: #37474f;
  opacity: 0.9;
}
.fa-pencil {
  margin-right: 5px;
}
</style>
<style lang="scss">
.StudentTutorsModalEdit {
  .multiselect__tags {
    border: 0;
  }
  .vdp-datepicker {
    input {
      height: 40px;
      border: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// StudentTutorsModalEdit.vue?4aa1e742